/**
 * @generated SignedSource<<0b4107d195cc09e351a6f65ff92a02f7>>
 * @relayHash 0e6b913da3ca80570d2232453a460c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcfe9939769b56d8b4a5c327dde03375eb0d9a2639a738ce027c3f4c80b09d70

import type { ConcreteRequest } from 'relay-runtime';
export type JiraSidebarMenuDisplayMode = "MOST_RECENT_ONLY" | "STARRED" | "STARRED_AND_RECENT" | "%future added value";
export type ProjectsViewOptionsQuery$variables = {
  cloudId: string;
};
export type ProjectsViewOptionsQuery$data = {
  readonly jira_projectsSidebarMenu: {
    readonly displayMode: JiraSidebarMenuDisplayMode | null;
  } | null;
};
export type ProjectsViewOptionsQuery = {
  response: ProjectsViewOptionsQuery$data;
  variables: ProjectsViewOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "displayMode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectsViewOptionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectsViewOptionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dcfe9939769b56d8b4a5c327dde03375eb0d9a2639a738ce027c3f4c80b09d70",
    "metadata": {},
    "name": "ProjectsViewOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "878985a959db09740786f4815e3cda55";

export default node;
